import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserSecret, FaSignOutAlt } from 'react-icons/fa';

const ImpersonationBanner = () => {
    const navigate = useNavigate();
    const isAdminImpersonating = localStorage.getItem('adminToken'); // Check if backup exists

    if (!isAdminImpersonating) return null; // Don't show if normal user

    const handleExit = () => {
        // 1. Restore Admin Token
        const adminToken = localStorage.getItem('adminToken');
        const adminUser = localStorage.getItem('adminUser');

        localStorage.setItem('token', adminToken);
        localStorage.setItem('DDoctorUser', adminUser);

        // 2. Clear Backup
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');

        // 3. Redirect back to HQ
        navigate('/admin/dashboard');
        window.location.reload(); // Force refresh to clear old state
    };

    return (
    <div className="impersonation-banner">
        <div className="d-flex align-items-center">
            <div className="bg-white text-danger rounded-circle p-1 d-flex justify-content-center align-items-center me-3" style={{width: 28, height: 28}}>
                <FaUserSecret size={16}/>
            </div>
            <span>
                <span className="fw-bold opacity-75 me-2">VIEWING MODE:</span> 
                You are currently impersonating a user.
            </span>
        </div>
        
        <button onClick={handleExit} className="banner-exit-btn d-flex align-items-center">
            <FaSignOutAlt className="me-2"/> Return to Admin Console
        </button>
    </div>
    );
};

export default ImpersonationBanner;